export default __webpack_public_path__ + "static/media/sai-banner.61d67f26.png";